<!-- ----------------------------------------------- -->
<template>
  <v-sheet tile class="com-pc-card tm-pc-no-shadow" style="height: 100%;">
    <v-row ref="graphWrapper" no-gutters style="height: 100%;">
      <div class="content-graph">
        <!-- 左軸 -->
        <div
          :id="'content-coast-graph-left' + idx"
          class="graph-label"
          v-html="getLeftLabel"
        />
        <!-- グラフ領域 -->
        <div
          :id="'content-coast-graph-center' + idx"
          class="graph-area"
          :class="{ 'horizontal-scrollbar': isExpansion }"
          :width="width"
          :height="height"
          v-html="getGraph"
        />
        <!-- 右軸 -->
        <div
          :id="'content-coast-graph-right' + idx"
          class="graph-label"
          v-html="getRightLabel"
        />
        <div
          :id="'content-coast-graph-legend' + idx"
          ref="legend"
          class="graph-legend"
          v-show="isLegend"
          v-html="getLegend"
        />
      </div>
    </v-row>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]海岸 グラフカード
 * TmCoastGraph.vue
 * @author LIS
 */

import libCommonGraph from "../../lib/graph/CommonGraph";
import libCoastGraph from "../../lib/graph/CoastGraph";

export default {
  name: "tm-coast-graph",
  props: {
    /** 親要素の幅 */
    width: {
      type: Number,
      default: 500,
    },
    /** 親要素の高さ */
    height: {
      type: Number,
      default: 500,
    },
    /** 風向・風速グラフ表示 */
    showWind: {
      type: Boolean,
      default: false,
    },
    /** 潮位グラフ表示 */
    showTide: {
      type: Boolean,
      default: true,
    },
    /** 最大波グラフ表示 */
    showMaxWave: {
      type: Boolean,
      default: false,
    },
    /** 1/3有義波グラフ表示 */
    showOnthWave: {
      type: Boolean,
      default: false,
    },
    /** 拡大/全体指定 */
    isExpansion: {
      type: Boolean,
      default: true,
    },
    /** 時間/10分指定 */
    isHour: {
      type: Boolean,
      default: true,
    },
    /** 凡例表示 */
    isLegend: {
      type: Boolean,
      default: false,
    },
    /** グラフを複数並べる際にidを差別化する識別子 */
    idx: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.setLegendPosition();

    const graphElement = document.getElementById(
      "content-coast-graph-center" + this.idx
    );
    libCommonGraph.startScrollGraph(graphElement);
    // エラー情報出力
    this.$nextTick(() => {
      if (graphElement == undefined) {
        this.$log.debug(
          "[TmGraph]" + this.$store.state.app.config.messageConfig.svgErrCslMsg
        );
      }
    });
  },
  updated() {
    this.setLegendPosition();

    const graphElement = document.getElementById(
      "content-coast-graph-center" + this.idx
    );
    libCommonGraph.startScrollGraph(graphElement);
    // エラー情報出力
    this.$nextTick(() => {
      if (graphElement == undefined) {
        this.$log.debug(
          "[TmGraph]" + this.$store.state.app.config.messageConfig.svgErrCslMsg
        );
      }
    });
  },
  beforeDestroy() {
    libCommonGraph.stopScrollGraph("content-coast-graph-center" + this.idx);
  },
  computed: {
    /** 海岸情報(時間) 取得 */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.graph.hour;
      },
    },
    /**
     * 海岸情報(10分) 取得
     */
    min10List: {
      get() {
        return this.$store.state.Telemeter.selectedTm.graph.min10;
      },
    },
    /** 観測値 */
    obsValue: {
      get() {
        var val = [];
        if (this.isHour) {
          val = val.concat(this.hourList.value);
        } else {
          val = val.concat(this.min10List.value);
        }
        return val;
      },
    },
    /** 観測所情報 */
    specValue: {
      get() {
        if (this.isHour) {
          return this.hourList.spec;
        } else {
          return this.min10List.spec;
        }
      },
    },
    /** 観測情報 */
    obsInfo: {
      get() {
        return {
          value: this.obsValue,
          spec: this.specValue,
        };
      },
    },
    /** 描画パラメータ */
    viewProp: {
      get() {
        return {
          width: this.width,
          height: this.isExpansion ? this.height - 14 : this.height,
          isExp: this.isExpansion,
          isHour: this.isHour,
          showWind: this.showWind,
          showTide: this.showTide,
          showMaxwave: this.showMaxWave,
          showOnthwave: this.showOnthWave,
        };
      },
    },
    /** グラフ左軸画像取得 */
    getLeftLabel() {
      if (this.dispGraph()) {
        return libCoastGraph.getSvgLeftLabel(this.obsInfo, this.viewProp);
      } else {
        return null;
      }
    },
    /** グラフ画像取得 */
    getGraph() {
      if (this.dispGraph()) {
        return libCoastGraph.getSvgGraph(this.obsInfo, this.viewProp);
      } else {
        return null;
      }
    },
    /** グラフ右軸画像取得 */
    getRightLabel() {
      if (this.dispGraph()) {
        return libCoastGraph.getSvgRightLabel(this.obsInfo, this.viewProp);
      } else {
        return null;
      }
    },
    /** 凡例画像取得 */
    getLegend() {
      if (this.dispGraph()) {
        return libCoastGraph.getSvgLegend(this.obsInfo, this.viewProp);
      } else {
        return null;
      }
    },
  },
  methods: {
    /** 凡例表示位置設定 */
    setLegendPosition() {
      const legendElement = this.$refs.legend;
      if (legendElement != null) {
        legendElement.style.left =
          libCommonGraph.computeViewLabelWidth(this.width) + 5 + "px";
      }
    },
    dispGraph() {
      if (this.obsValue.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    /** 波高のみの場合は限界値0.0m */
    tideGraphMinChange() {
      // 波高のみ表示の場合
      if (!this.showTide && (this.showMaxWave || this.showOnthWave)) {
        // 波高 最小値 判定

        // 波高 最小値 設定
        this.$store.state.Telemeter.selectedTm.graph.min10.spec.tide.min = this.$store.state.Telemeter.selectedTm.graph.min10.spec.wave.minOrigin;
        this.$store.state.Telemeter.selectedTm.graph.hour.spec.tide.min = this.$store.state.Telemeter.selectedTm.graph.hour.spec.wave.minOrigin;
      } else {
        // 潮位 最小値 判定

        // 潮位 最小値 設定
        this.$store.state.Telemeter.selectedTm.graph.min10.spec.tide.min = this.$store.state.Telemeter.selectedTm.graph.min10.spec.tide.minOrigin;
        this.$store.state.Telemeter.selectedTm.graph.hour.spec.tide.min = this.$store.state.Telemeter.selectedTm.graph.hour.spec.tide.minOrigin;
      }
    },
  },
  watch: {
    showTide() {
      this.tideGraphMinChange();
    },
    showMaxWave() {
      this.tideGraphMinChange();
    },
    showOnthWave() {
      this.tideGraphMinChange();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
